module.exports = __webpack_public_path__ + "img/u237.355c5940.svg";